import { MutationOptions, useMutation, useQueryClient } from "react-query";
import { API_URL, APIError, APIResponse, post } from "../api";

function useGenerateVirtualAccount<T>(
  options?: MutationOptions<APIResponse<T>, APIError, any>
) {
  const client = useQueryClient();
  const {
    isLoading: generatingFundingWallet,
    isError: isFundingWalletError,
    error: generatingFundingWalletError,
    mutate: generateFundingWallet,
  } = useMutation(
    async (variables?: any) => {
      return await post(
        API_URL + "/account/user/generate-virtual-account",
        variables,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${await localStorage.getItem("token")}`,
          },
        }
      );
    },
    {
      ...options,
      onSettled() {
        client.invalidateQueries("virtual-account");
      },
    }
  );

  return {
    generateFundingWallet,
    isFundingWalletError,
    generatingFundingWalletError,
    generatingFundingWallet,
  };
}

export default useGenerateVirtualAccount;
